import { cloneDeep } from 'lodash'
import { getValue, createUuid, textOverflow, toNumber, computedAutoWidth, updateColsItem, computedExcludeSortWidth } from '../utils'
import { headerHeight, cellPaddingWidth, maskSec } from '../config'
import textFlexWidget from '../widget/text-flex'
import { useAutoWidgetPlugins } from '../widget/text-flex/auto-widget'

export const INNER = '__inner_'
export const AUTO_WIDTH = 'auto'
const INDEX_COL = {
  key: '$$index',
  label: '序号',
  width: 40,
  fixed: 'left',
  show: true
}

const SELECTION_COL = {
  key: '$$selection',
  label: '',
  width: 40,
  fixed: 'left',
  show: true
}

const OPERATION_COL = {
  key: '$$operation',
  label: '操作',
  width: 60,
  fixed: 'left',
  show: true
}

const sortOrder = {
  descending: 2,
  ascending: 1
}

export default {
  mounted () {
    this.colWidthMap = {} // 记录改变的列宽
    this.allColData = [] // 处理列坐标数据 {_index: 0, x: 0, width: 0, ...}
    this.allRowData = [] // 处理行坐标数据 {index: 0, y: 0}
    this.flatData = [] // 扁平化后的行数据 例如： {'a.b.c': 'xxx'}
    this.cachedFlatData = [] // 扁平化后的缓存数据，默认排序的时候用到
    this.allFixedRowData = [] // 右边操作栏 按钮数组
    // 显示数据
    this.displayCol = [] // 画布的列坐标数据
    this.displayRow = [] // 画布的行坐标数据
    this.displayRowData = [] // 画布的行显示数据
    this.displayOverRowData = [] // 标记每行的各列是否有溢出气泡 {'a.b.x': false}
    // 浮动列
    this.fixedLeftCol = [] // 左边固定列
    this.fixedLeftWidth = 0 // 左边固定列总宽度
    this.checkboxRows = {} // checkbox选择框容器
    this.buttonDisabledRows = {} // 按钮禁用行
    this.uploadDisabledRows = {} // 上传行
    this.maskCol = {} // 监控列
    this.virtualCol = {} // 虚拟字段列
    this.excludeSortWidth = 0
    this.excludeSortIndex = 0
    this.excludeSort = { $$index: '$$index', $$selection: '$$selection', $$operation: '$$operation' }
    this.twoHeander = false
    this.textAlignMap = new Map()
    this._useAutoWidgetInstance = useAutoWidgetPlugins(this)
  },
  methods: {
    /*
      当前这个函数为收起折叠动画的优化函数，在低端设备该函数耗时太长导致掉帧卡顿。
      该函数调整范围：【抽离数据遍历部分】
    */
    integrateData1 () {
      const { column, ratio, fixedRight, selection, options, operation, getButtonOptions, getImageOptions, getCheckedOptions, getUploadOptions, page, buttonOptions } = this
      let sindex = 0
      let cols = []
      let leftArr = []
      // index计算宽度
      let { pageSize = 0, currentPage = 0 } = page
      let plength = (pageSize * currentPage + '').length
      let indexCol = plength * 10
      INDEX_COL.width = indexCol < 40 ? 40 : indexCol
      // 复选框
      if (selection) {
        sindex++
        leftArr.push({ ...SELECTION_COL })
      }
      // 序号
      if (options.showIndex !== false) {
        sindex++
        leftArr.push({ ...INDEX_COL })
      }
      // 操作列
      if (fixedRight) {
        sindex++
        operation.width = parseInt(operation.width) || OPERATION_COL.width
        leftArr.push({ ...OPERATION_COL, width: operation.width, label: operation.label })
      }
      this.excludeSortIndex = sindex
      // 排除 show 为 false 的列
      column.forEach(v => {
        if (v.show) {
          let width = this.colWidthMap[v.key] || v.width
          // 判断列的宽度是否为“auto”，是则根据数据来测量，第一次的this.data是[],所以计算的是 label的宽度。
          if (width === AUTO_WIDTH) {
            width = computedAutoWidth(v, this.data, this.textCtx)
          }
          const obj = { ...v, width: parseInt(width) }
          if (Array.isArray(obj.children) && obj.children.length > 0) {
            let w = 0
            let pIndex = 0
            let hasFixed = obj.children.some(child => child.fixed && child.fixed === 'left')
            obj.children.forEach((item, index, arr) => {
              if (item.show) {
                let iw = parseInt(this.colWidthMap[item.key] || item.width)
                // 二级头处理 width 为 ”auto“的场景。
                if (item.width === AUTO_WIDTH) {
                  iw = computedAutoWidth(item, this.data, this.textCtx, v)
                  item.width = iw
                }
                const col = { ...item, width: iw }
                w += iw
                col._parent = obj
                col._parentkey = obj.key
                if (index === arr.length - 1) {
                  col._last = true
                }
                col._pindex = pIndex++
                // 2021-08-19 兼容处理，如果二级头有一个或者一级头有 fixed，则全部固定
                if ((obj.fixed && obj.fixed === 'left') || hasFixed) {
                  col.fixed = 'left'
                  leftArr.push(col)
                } else {
                  cols.push(col)
                }
              }
            })
            obj.width = w
            this.twoHeander = true
          } else {
            obj.fixed && obj.fixed === 'left' ? leftArr.push(obj) : cols.push(obj)
          }
        }
      })
      cols = leftArr.concat(cols)
      leftArr = null
      const alen = cols.length
      // this.allFixedRowData = []
      // 设置列
      let x = 0
      this.excludeSortWidth = 0
      const sort = options.defaultSort
      for (let i = 0; i < alen; i++) {
        let col = cols[i]
        let key = col.key
        if (i > 0) {
          x += cols[i - 1].width
        }
        let width = (this.colWidthMap[key] || col.width) * ratio
        Object.assign(col, { _index: i, x, width })
        // 计算出二级头的初始位置
        if (col._pindex === 0) {
          col._parent.x = x
        }
        if (i < sindex) {
          this.excludeSortWidth += width
          continue
        }
        // 设置加密字段
        if (this.maskCol.hasOwnProperty(key) || this.virtualCol.hasOwnProperty(key)) {
          col._showButton = true
        }
        // 设置按钮
        if (getButtonOptions.includes(key) && buttonOptions[key]) {
          let opt = buttonOptions[key]
          col._showButton = true
          col.button = opt.label
          col.icon = !!opt.icon
          col.color = !!opt.color
          col.dbclick = opt.dbclick
        }
        // 设置图片
        if (getImageOptions.includes(key)) {
          col._showImage = true
        }
        // 设置checkbox选择框
        if (getCheckedOptions.includes(key)) {
          col._showCheckbox = true
        }
        // 设置upload
        if (getUploadOptions.includes(key)) {
          col._showUpload = true
        }
        // 过滤器
        if (col.filter) {
          if (col.filter.type && col.filter.args) {
            let func = this.$filter[col.filter.type]
            if (func) {
              col.formatter = (row, column, val) => func(val, ...col.filter.args)
            }
          } else {
            // 不显示秒，minute 替换 time
            if (col.filter === 'time') {
              col.filter = 'minute'
            }
            let func = this.$filter[col.filter]
            if (func) {
              // 9级组织
              if (col.filter === 'deptFilter') {
                col.formatter = (row, column, val) => func(val, column.dept)
              } else {
                col.formatter = (row, column, val) => func(val)
              }
            }
          }
        }

        // 2023-02-18 增加单元格功能，迁移加密解密场景
        if (col.widgetType) {
          col._showButton = false
        }

        // textFlexWidget
        if (col.textFlexWidget) {
          let func = textFlexWidget.format.bind(this)
          col.formatter = (row, column, val) => func(row, column, val)
        }

        // 默认远程排序的字段
        if (sort && sort.prop === key) {
          if (!col.sortKeys) {
            col.sortKeys = sort.keys
          }
          if (!this.sortCol.col.key) {
            this.sortCol.col = col
            this.sortCol.num = sortOrder[sort.order || sortOrder.ascending]
          }
        }
      }
      if (options.headerHeight) {
        this.headerHeight = this.twoHeander ? headerHeight + options.headerHeight : options.headerHeight
      } else {
        this.headerHeight = this.twoHeander ? headerHeight * 2 : headerHeight
      }
      this._calculateAuthPlugin && this._calculateAuthPlugin.usePluginButtonDisabledRows()
      // 判断cols中是否存在 auto 的宽度，若有则 更新 对应的 宽度以及 x坐标
      updateColsItem(cols, this.flatData, this.textCtx, ratio, this.colWidthMap)
      // 更新excludeSortWidth 因为cols中可能由于 ”auto“ 的宽度而发生变化
      this.excludeSortWidth = computedExcludeSortWidth(cols, sindex) || this.excludeSortWidth
      this.allColData = cols
      this.getFixedLeft()
      this.getFixedLeftWidthMap()
    },
    // 整合，行列坐标，处理数据
    integrateData (isLocal) {
      const { column, data, rowH, ratio, fixedRight, selection, checkedRow, options, operation, getButtonOptions, getImageOptions, getCheckedOptions, getUploadOptions, page, buttonOptions } = this
      let sindex = 0
      let cols = []
      let leftArr = []
      // index计算宽度
      let { pageSize = 0, currentPage = 0 } = page
      let plength = (pageSize * currentPage + '').length
      let indexCol = plength * 10
      INDEX_COL.width = indexCol < 40 ? 40 : indexCol
      // 复选框
      if (selection) {
        sindex++
        leftArr.push({ ...SELECTION_COL })
      }
      // 序号
      if (options.showIndex !== false) {
        sindex++
        leftArr.push({ ...INDEX_COL })
      }
      // 操作列
      if (fixedRight) {
        sindex++
        operation.width = parseInt(operation.width) || OPERATION_COL.width
        leftArr.push({ ...OPERATION_COL, width: operation.width, label: operation.label })
      }
      this.excludeSortIndex = sindex
      // 排除 show 为 false 的列
      column.forEach(v => {
        if (v.show) {
          let width = this.colWidthMap[v.key] || v.width
          // 判断列的宽度是否为“auto”，是则根据数据来测量，第一次的this.data是[],所以计算的是 label的宽度。
          if (width === AUTO_WIDTH) {
            width = computedAutoWidth(v, this.data, this.textCtx)
          }
          const obj = { ...v, width: parseInt(width) }
          if (Array.isArray(obj.children) && obj.children.length > 0) {
            let w = 0
            let pIndex = 0
            let hasFixed = obj.children.some(child => child.fixed && child.fixed === 'left')
            obj.children.forEach((item, index, arr) => {
              if (item.show) {
                let iw = parseInt(this.colWidthMap[item.key] || item.width)
                // 二级头处理 width 为 ”auto“的场景。
                if (item.width === AUTO_WIDTH) {
                  iw = computedAutoWidth(item, this.data, this.textCtx, v)
                  item.width = iw
                }
                const col = { ...item, width: iw }
                w += iw
                col._parent = obj
                col._parentkey = obj.key
                if (index === arr.length - 1) {
                  col._last = true
                }
                col._pindex = pIndex++
                // 2021-08-19 兼容处理，如果二级头有一个或者一级头有 fixed，则全部固定
                if ((obj.fixed && obj.fixed === 'left') || hasFixed) {
                  col.fixed = 'left'
                  leftArr.push(col)
                } else {
                  cols.push(col)
                }
              }
            })
            obj.width = w
            this.twoHeander = true
          } else {
            obj.fixed && obj.fixed === 'left' ? leftArr.push(obj) : cols.push(obj)
          }
        }
      })
      cols = leftArr.concat(cols)
      leftArr = null
      const alen = cols.length
      const rows = []
      this.allFixedRowData = []
      // 设置列
      let x = 0
      this.excludeSortWidth = 0
      const sort = options.defaultSort
      for (let i = 0; i < alen; i++) {
        let col = cols[i]
        let key = col.key
        if (i > 0) {
          x += cols[i - 1].width
        }
        let width = (this.colWidthMap[key] || col.width) * ratio
        Object.assign(col, { _index: i, x, width })
        // 计算出二级头的初始位置
        if (col._pindex === 0) {
          col._parent.x = x
        }
        if (i < sindex) {
          this.excludeSortWidth += width
          continue
        }
        // 设置加密字段
        if (this.maskCol.hasOwnProperty(key) || this.virtualCol.hasOwnProperty(key)) {
          col._showButton = true
        }
        // 设置按钮
        if (getButtonOptions.includes(key) && buttonOptions[key]) {
          let opt = buttonOptions[key]
          col._showButton = true
          col.button = opt.label
          col.buttonSortable = opt.sortable
          col.icon = !!opt.icon
          col.color = !!opt.color
          col.dbclick = opt.dbclick
        }
        // 设置图片
        if (getImageOptions.includes(key)) {
          col._showImage = true
        }
        // 设置checkbox选择框
        if (getCheckedOptions.includes(key)) {
          col._showCheckbox = true
        }
        // 设置upload
        if (getUploadOptions.includes(key)) {
          col._showUpload = true
        }
        // 过滤器
        if (col.filter) {
          if (col.filter.type && col.filter.args) {
            let func = this.$filter[col.filter.type]
            if (func) {
              col.formatter = (row, column, val) => func(val, ...col.filter.args)
            }
          } else {
            // 不显示秒，minute 替换 time
            if (col.filter === 'time') {
              col.filter = 'minute'
            }
            let func = this.$filter[col.filter]
            if (func) {
              // 9级组织
              if (col.filter === 'deptFilter') {
                col.formatter = (row, column, val) => func(val, column.dept)
              } else {
                col.formatter = (row, column, val) => func(val)
              }
            }
          }
        }

        // textFlexWidget
        if (col.textFlexWidget) {
          let func = textFlexWidget.format.bind(this)
          col.formatter = (row, column, val) => func(row, column, val)
        }

        // 默认远程排序的字段
        if (sort && sort.prop === key) {
          if (!col.sortKeys) {
            col.sortKeys = sort.keys
          }
          if (!this.sortCol.col.key) {
            this.sortCol.col = col
            this.sortCol.num = sortOrder[sort.order || sortOrder.ascending]
          }
        }
      }
      if (options.headerHeight) {
        this.headerHeight = this.twoHeander ? headerHeight + options.headerHeight : options.headerHeight
      } else {
        this.headerHeight = this.twoHeander ? headerHeight * 2 : headerHeight
      }
      // this.vertical.style.top = this.headerHeight + 'px'
      // 对数据循环
      const diffY = this.headerHeight - this.rowHeight
      const res = data.map((item, index) => {
        // 整合画横线的坐标
        rows.push({ index, y: diffY + (index + 1) * rowH })
        if (fixedRight) {
          // 有可能是函数，返回必须是数组
          let opts = Array.isArray(operation.options) ? operation.options : operation.options(item)
          // this.allFixedRowData.push(this.operationDisabled(opts, item))
          this.allFixedRowData.push(this.operationStatus(opts, item))
        }
        // 设置button的disable
        this._calculateAuthPlugin && this._calculateAuthPlugin.setButtonDisabledRows(item, index)

        // 只能设置一个checkbox
        if (getCheckedOptions.length > 0) {
          this.setCheckStatus(item, index)
        }
        // 只能设置一个upload的disable
        if (getUploadOptions.length > 0) {
          this.setUploadStatus(item, index)
        }
        const obj = {}
        for (let i = sindex; i < alen; i++) {
          const col = cols[i]
          const key = col.key
          // 2023-03-11 默认右键复制功能复制格式化后的数据
          const showFormatValWhenCopy = col.showFormatValWhenCopy !== false
          // 取到mask的值
          const maskKey = key + 'Mask'
          const virtualKey = key + 'Virtual'
          let maskVal = getValue(maskKey, item)
          let virtualVal = getValue(virtualKey, item)
          // 如果有mask的值
          if (maskVal) {
            this.maskCol[key] = 1
            obj[maskKey] = maskVal
            col._showButton = true // 设置加密字段
            col.showFormatValWhenCopy = showFormatValWhenCopy
          }
          if (virtualVal) {
            this.virtualCol[key] = 1
            obj[virtualKey] = virtualVal
            col._showButton = true // 设置加密字段
            col.showFormatValWhenCopy = showFormatValWhenCopy
          }

          // 2023-02-18 增加单元格功能，迁移加密解密场景
          if (col.widgetType) {
            col._showButton = false
          }
          // 格式化数据
          let val = getValue(key, item)
          // formatter的敏感字段，敏感规则优先级高
          if (!val && getValue(key + 'MaskSec', item) !== undefined) {
            // 敏感字段显示为6个星号
            val = maskSec
            col.showFormatValWhenCopy = showFormatValWhenCopy
          } else if (col.formatter && typeof col.formatter === 'function') {
            val = col.formatter(item, col, val)
            col.showFormatValWhenCopy = showFormatValWhenCopy
          }
          obj[key] = val
        }

        obj._index = index + 1
        obj._gtableuuid = createUuid()
        // 本地数据重新渲染时，复用已勾选的行数据的 _gtableuuid
        if (isLocal && checkedRow) {
          let checked = checkedRow.find(v => v._index === index + 1)
          if (checked && checked._gtableuuid) {
            obj._gtableuuid = checked._gtableuuid
          }
        }
        obj._pageIndex = (index + 1) + page.pageSize * (page.currentPage - 1)

        // 特殊保留字段
        const itemInnerKeyList = Object.keys(item).filter(key => key.indexOf(INNER) === 0)
        itemInnerKeyList.length && itemInnerKeyList.forEach(innerKey => {
          obj[innerKey] = item[innerKey]
        })

        // 禁用复选框
        obj._disabledCheck = (this.options.paintCheckRow && this.options.paintCheckRow(item, index, this)) || false

        return obj
      })

      this._calculateAuthPlugin && this._calculateAuthPlugin.usePluginButtonDisabledRows()

      // 判断cols中是否存在 auto 的宽度，若有则 更新 对应的 宽度以及 x坐标
      updateColsItem(cols, res, this.textCtx, ratio, this.colWidthMap)

      // 更新excludeSortWidth 因为cols中可能由于 ”auto“ 的宽度而发生变化
      this.excludeSortWidth = computedExcludeSortWidth(cols, sindex) || this.excludeSortWidth

      this.flatData = res
      this.allColData = cols
      this.allRowData = rows
      this.cachedFlatData = JSON.parse(JSON.stringify(res))
      this.getFixedLeft()
      this.getFixedLeftWidthMap()
    },
    // 2022-0806 左边操作列状态初始化
    operationStatus (opts, row) {
      const arr = cloneDeep(opts)
      return arr.map(v => {
        // 权限控制
        v.disabled = this.authDisabled(v, row)
        v.label = typeof v.label === 'function' ? v.label(row) : v.label
        v.show = typeof v.show === 'function' ? v.show(row) : (v.show === undefined ? true : v.show)
        return v
      })
    },
    // 左边操作列禁用状态
    operationDisabled (opts, row) {
      const arr = cloneDeep(opts)
      return arr.map(v => {
        // 权限控制
        v.disabled = this.authDisabled(v, row)
        return v
      })
    },
    // 设置按钮禁用状态
    setButtonDisable (item, index) {
      const { buttonOptions, getButtonOptions } = this
      for (let key of getButtonOptions) {
        // 权限控制
        let disabled = this.authDisabled(buttonOptions[key], item)
        if (this.buttonDisabledRows[index]) {
          this.buttonDisabledRows[index][key] = disabled
        } else {
          this.buttonDisabledRows[index] = {}
          this.buttonDisabledRows[index][key] = disabled
        }
      }
    },
    // 设置默认选择框选中状态
    setCheckStatus (item, index) {
      const { checkedOptions, getCheckedOptions } = this
      this.checkboxRows[index] = getCheckedOptions.reduce((obj, key) => {
        let checked = false
        let disabled = false
        if (checkedOptions[key]) {
          if (typeof checkedOptions[key].default === 'function') {
            checked = checkedOptions[key].default(item, key)
          } else {
            checked = !!checkedOptions[key].default
          }
          if (typeof checkedOptions[key].disabled === 'function') {
            disabled = checkedOptions[key].disabled(item, key)
          } else {
            disabled = !!checkedOptions[key].disabled
          }
        }
        obj[key] = { checked, disabled }
        return obj
      }, {})
    },
    // 设置上传disable状态
    setUploadStatus (item, index) {
      const { uploadOptions, getUploadOptions } = this
      const ckey = getUploadOptions[0]
      let disabled = false
      if (uploadOptions[ckey]) {
        if (typeof uploadOptions[ckey].disabled === 'function') {
          disabled = uploadOptions[ckey].disabled(item)
        } else {
          disabled = !!uploadOptions[ckey].disabled
        }
      }
      this.uploadDisabledRows[index] = { disabled }
    },
    // 获取左边固定列
    getFixedLeft () {
      const { allColData } = this
      this.fixedLeftWidth = this.getFixedLeftWidth()
      this.fixedLeftCol = allColData.filter(item => item.fixed === 'left')
    },
    getFixedLeftWidth () {
      const { allColData } = this
      const leftWidth = allColData.reduce((acc, cur) => cur.fixed === 'left' ? (acc += cur.width) : acc, 0)
      this.fixedLeftWidth = leftWidth
      return leftWidth
    },
    getFixedLeftWidthMap () {
      // 获取固定列的渲染宽度，但只是第一次渲染的。用来做最小的拖拽的宽度。这样就可以免于在未主动设置的时候，不会出现错位的问题，因为首次一般都是处理好的
      if (this.fixedLeftWidthMap) {
        return
      }
      this.fixedLeftWidthMap = this.fixedLeftCol.reduce((obj, cur) => {
        if (cur.fixed === 'left') {
          obj[cur.key] = cur.width
        }
        return obj
      }, {})
    },
    computedhScrollLeft () {
      const disW = this.horizontal.offsetWidth - this.hScrollbar.offsetWidth
      const overWidth = this.canvasConfig.aw - this.canvas.offsetWidth
      this.hScrollbar.style.left = (this.scroll.disx / overWidth) * disW + 'px'
    },
    // 获取显示的行数
    getDisplayRow () {
      const { allRowData, rowH, scroll, canvas, scaleRatio } = this
      if (!canvas) {
        return
      }
      // 从超出部分算起，比如有10行已经是滚动出canvas之外了，就从10开始算起
      // 算到canvas高度结束，比如20行结束，取到多少行就是 10 - 20
      let num = Math.floor(scroll.disy / rowH)
      let len = allRowData.length
      let h = 0
      let arr = []
      const ch = canvas.height / scaleRatio
      for (let i = num; i < len; i++) {
        h += rowH
        if (h > ch) {
          break
        }
        arr.push({ ...allRowData[i] })
      }
      this.displayRow = arr
    },
    // 获取显示列
    getDisplayCol () {
      const { allColData, scroll, canvas, scaleRatio } = this
      if (!canvas) {
        return
      }
      // 计算显示列 同理与显示行计算
      let disx = scroll.disx
      let len = allColData.length
      const arr = []
      let index = 0
      const cw = canvas.width / scaleRatio
      // 拿到超出显示列的index
      for (let i = 0; i < len; i++) {
        if (allColData[i].x > disx) {
          index = i - 1
          break
        }
      }
      // 计算从显示列到 canvas 宽度的距离显示的列
      for (; index < len; index++) {
        if (!allColData[index]) {
          continue
        }
        if (allColData[index].x < cw + disx) {
          arr.push(allColData[index])
        } else {
          break
        }
      }
      this.displayCol = arr
    },
    // 文字溢出处理
    handleShowText () {
      const { displayCol, displayRow, flatData, ratio, fixedLeftCol, textCtx, excludeSort } = this
      let arr = []
      let voarr = []
      const colArr = fixedLeftCol.concat(displayCol)
      if (displayRow.length > 0) {
        displayRow.forEach(item => {
          if (typeof item.index === 'number') {
            let res = {}
            let vo = {}
            res._index = item.index
            vo._index = item.index
            // 原来的代码
            // colArr.forEach(obj => {
            //   // 处理溢出隐藏数据
            //   const { over, text } = textOverflow(textCtx, flatData[item.index][obj.key], obj.width, ratio)
            //   res[obj.key] = text
            //   vo[obj.key] = over
            // })

            // 新的优化
            for (let i = 0; i < colArr.length; i++) {
              const col = colArr[i]
              let key = col.key
              // 不需要计算溢出的列  直接跳过
              if (key === excludeSort.$$index ||
                key === excludeSort.$$selection ||
                key === excludeSort.$$operation ||
                col._showCheckbox ||
                col._showImage ||
                col._showUpload
              ) {
                continue
              }
              const { over, text, tw } = textOverflow(textCtx, flatData[item.index][key], col.width, ratio)
              // 单元格居中对齐、右对齐
              if (col.textAlign && (col.textAlign === 'right' || col.textAlign === 'center') && !over) {
                const textLeft = col.textAlign === 'right' ? col.width - cellPaddingWidth - tw : (col.width - tw) / 2
                let obj = this.textAlignMap.get(item.index)
                if (obj) {
                  obj[key] = textLeft
                } else {
                  obj = { [key]: textLeft }
                }
                this.textAlignMap.set(item.index, obj)
              }
              res[key] = text
              vo[key] = over
            }
            arr.push(res)
            voarr.push(vo)
          }
        })
      }
      this.displayRowData = arr
      this.displayOverRowData = voarr
    },
    // 计算函数
    calculate () {
      this.getDisplayRow()
      this.getDisplayCol()
      this.handleShowText()
      this.paint()
    },
    // 获取点击的行和列
    getRowAndCol (x, y, left) {
      const { allColData, allRowData, scroll, ratio, rowH } = this
      const disx = left ? 0 : scroll.disx
      const disy = scroll.disy
      let cRow = {}
      let cCol = {}
      for (let row of allRowData) {
        if (y < (row.y - disy + rowH) / ratio) {
          cRow = row
          break
        }
      }
      for (let col of allColData) {
        if (x < (col.x + col.width - disx) / ratio) {
          cCol = col
          break
        }
      }
      return {
        col: cCol,
        row: cRow
      }
    },
    // 升序
    riseSort (sortFn) {
      const { data, flatData, sortCol, options } = this
      const key = sortCol.col.key
      if (!sortFn || typeof sortFn !== 'function') {
        const sortType = sortCol.col.sortType
        sortFn = (a, b) => {
          let c = typeof a[key] === 'number' ? a[key] : (a[key] || '')
          let d = typeof b[key] === 'number' ? b[key] : (b[key] || '')
          if ((sortType && sortType === 'number') || typeof c === 'number') {
            return toNumber(c) - toNumber(d)
          }
          return c.localeCompare(d, 'zh')
        }
      }
      // TODO: 优化空间 直接可以用三路快排算法，时间复杂度是O(logn)
      // 2021-09-26 增加字段，控制是否用原始数据进行前端排序
      options.sortByOriginData ? data.sort(sortFn) : flatData.sort(sortFn)
      this.calculate()
      this.$emit('sort-change', { remote: false, column: sortCol.col, prop: key, order: 'ascending' })
    },
    // 降序
    downSort (sortFn) {
      const { data, flatData, sortCol, options } = this
      const key = sortCol.col.key
      if (!sortFn || typeof sortFn !== 'function') {
        const sortType = sortCol.col.sortType
        sortFn = (a, b) => {
          let c = typeof a[key] === 'number' ? a[key] : (a[key] || '')
          let d = typeof b[key] === 'number' ? b[key] : (b[key] || '')
          if ((sortType && sortType === 'number') || typeof c === 'number') {
            return toNumber(d) - toNumber(c)
          }
          return d.localeCompare(c, 'zh')
        }
      }
      // TODO: 优化空间 直接可以用三路快排算法，时间复杂度是O(logn)
      // 2021-09-26 增加字段，控制是否用原始数据进行前端排序
      options.sortByOriginData ? data.sort(sortFn) : flatData.sort(sortFn)
      this.calculate()
      this.$emit('sort-change', { remote: false, column: sortCol.col, prop: key, order: 'descending' })
    },
    // 默认排序
    defaultSort () {
      this.flatData = JSON.parse(JSON.stringify(this.cachedFlatData))
      this.calculate()
    },
    // 计算活动的index
    calculateActiveIndex () {
      const { flatData, displayRow, activeRowIndex } = this
      let index = null
      if (activeRowIndex !== null) {
        for (let i = 0, len = displayRow.length; i < len; i++) {
          let iindex = displayRow[i].index
          if (flatData[iindex] && flatData[iindex]._index === activeRowIndex) {
            index = iindex
            break
          }
        }
      }
      return index
    },
    // 获取源数据
    getOriginData (col, row) {
      const { data, flatData } = this
      let value = ''
      let column = { ...col }
      if (flatData.length === 0) {
        return { value, column, rowData: null }
      }
      const index = flatData[row.index]._index - 1
      // const index = row.index
      const rowData = data[index]
      if (col.button) {
        value = typeof col.button === 'function' ? col.button(data[index]) : col.button
      } else {
        value = getValue(col.key, data[index])
      }
      return { value, column, rowData }
    },
    // 按钮的禁用
    btnDisabled (disabled, row) {
      return (typeof disabled === 'function') ? disabled(row) : !!disabled
    },
    // 权限的控制
    authDisabled ({ disabled, auth }, row) {
      return (auth && !this.$store.getters.permission.menus.includes(auth)) || this.btnDisabled(disabled, row)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/mixins/calculate.js